@if (indstillinger.standard.synlig || indstillinger.brugerdefineret.synlig) {
  <mat-card [formGroup]="formGroup">
    <mat-card-header>
      <mat-card-title>
        <h2 class="panel-header">{{ indstillinger.subtitel }}</h2>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      @if (indstillinger.standard.synlig && indstillinger.brugerdefineret.synlig) {
        <mat-slide-toggle formControlName="brugerdefineret"
          ><span>Brugerdefineret</span></mat-slide-toggle
          >
        }
        @if (
          (indstillinger.standard.synlig && !brugerdefineret) ||
          (indstillinger.standard.synlig && !indstillinger.brugerdefineret.synlig)
          ) {
          <div
            class="toggle-description"
            >
            {{ indstillinger.standard.tekst }}
          </div>
        }
        @if (indstillinger.brugerdefineret.synlig && brugerdefineret) {
          <div class="toggle-description">
            {{ indstillinger.brugerdefineret.tekst }}
          </div>
        }
        @if (brugerdefineret && indstillinger.brugerdefineret.synlig) {
          <dff-mat-slider-wrapper [suffix]="suffix">
            <mat-slider
              [max]="max"
              [min]="min"
              step="1"
              discrete
              aria-label="Juster procentdel"
              role="slider"
              type="range"
              [attr.aria-valuemin]="min"
              [attr.aria-valuemax]="max"
              [attr.aria-valuenow]="formGroup.controls.vaerdi.value"
              >
              <input matSliderThumb type="range" formControlName="vaerdi" />
            </mat-slider>
          </dff-mat-slider-wrapper>
        }
      </mat-card-content>
    </mat-card>
  }
